import SimpleBar from 'simplebar';
import { observeElement } from '@uvocore-front/utils';

// Seo Text Horizontal Scroll
observeElement({
  element: '[data-seotext-horizontal]',
  marginValue: 400,
  callback: selector => {
    // eslint-disable-next-line no-new
    const simpleBar = new SimpleBar(selector, {
      autoHide: false,
    });
    if (
      !('ontouchstart' in window && navigator.maxTouchPoints > 0 && navigator.msMaxTouchPoints > 0)
    ) {
      const slider = simpleBar.getScrollElement();
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', e => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
      });
    }
  },
});
